// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__7ZQ4t","spin":"Header_spin__PhOU1","loader":"Header_loader__9I1yM"};